import Country from '~/Api/Country/Country';

export enum ErrorCode {
	cannotChangeSettingsForNonMemberProducts = 'bulgaria-max-price-calculation-cannot-change-settings-for-non-member-products',
	requiredProductSettingsMissing = 'bulgaria-max-price-calculation-required-product-settings-is-missing',
	requiresMinOneReferenceProduct = 'bulgaria-max-price-calculation-requires-at-least-one-reference-country-product',
	requiresMaxOneReferenceProduct = 'bulgaria-max-price-calculation-requires-at-most-one-product-for-each-country',
	requiresReferenceSettings = 'bulgaria-max-price-calculation-requires-reference-settings',
	illegalPriceTypeSelected = 'bulgaria-max-price-illegal-price-type-selected',
}

export class Error {
	public constructor(public code: string, public productId: string | null, public duplicateCountries: Country[]) {}
}
